import { DataStorage, type StorageData } from '@suntex.core/storage';
import { JsonObject } from '@suntex.core/types';
import { Entities_Login_StateInfo_Response } from '@suntex.fim/api-client';

import { IAuthStorage } from '../types';

interface LocalStorageData extends StorageData {
  jwt: string;
  login: Entities_Login_StateInfo_Response & JsonObject;
  loginToken: string;
}

export class LocalStorageAdapter implements IAuthStorage {
  private adapter: DataStorage<LocalStorageData>;

  constructor() {
    this.adapter = new DataStorage<LocalStorageData>(localStorage);
  }

  get jwt(): string | undefined {
    return this.adapter.get('jwt');
  }

  set jwt(jwt: string) {
    this.adapter.set('jwt', jwt);
  }

  get login(): Entities_Login_StateInfo_Response | undefined {
    return this.adapter.get('login');
  }

  set login(login: Entities_Login_StateInfo_Response) {
    this.adapter.set('login', { ...login });
  }

  get loginToken(): string | undefined {
    return this.adapter.get('loginToken');
  }

  set loginToken(loginToken: string) {
    this.adapter.set('loginToken', loginToken);
  }

  clear(): void {
    this.adapter.remove('jwt');
    this.adapter.remove('login');
    this.adapter.remove('loginToken');
  }

  onChange(callback: () => void): () => void {
    /* v8 ignore next */
    if (typeof window === 'undefined') return () => undefined;
    const controller = new AbortController();
    window.addEventListener(
      'storage',
      (event: StorageEvent) => {
        if (event.storageArea !== window.localStorage) return;
        if (event.key !== 'jwt' && event.key !== 'login' && event.key !== null)
          return;
        callback();
      },
      { signal: controller.signal },
    );
    return () => controller.abort();
  }
}
